import { $ } from '@starberry/components';

const TwoColumn = {
  $: 'Grid',
  props: {
    px: 12,
    templateColumns: { base: 'repeat(12, 1fr)' },
    gap: $('constants.globalGridGap'),
    pt: 0,
  },
  children: ({ leftColumn = [], leftColumnProps = {}, rightColumn = [], rightColumnProps = {} }) => [
    leftColumn.length && {
      $: 'GridItem',
      props: {
        colSpan: { base: 12, lg: 8 },
        ...leftColumnProps
      },
      children: leftColumn,
    },
    rightColumn.length && {
      $: 'GridItem',
      props: {
        colSpan: { base: 12, lg: 4 },
        ...rightColumnProps
      },
      children: rightColumn,
    },
  ],
};

export default TwoColumn;
